import React, { FC } from 'react';

import IconRenderer, { IconProps } from 'ui/icons/IconRenderer';

import icon from './file-text-filled.svg';

const IconFileTextFilled: FC<IconProps> = ({ className, style }) => (
  <IconRenderer
    iconHtml={icon}
    className={className}
    style={style}
  />
);

export default IconFileTextFilled;
